import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { plainToInstance } from 'class-transformer';
import AuthService from './authentication/AuthService';
import TokenService from './authentication/TokenService';
import qs from 'qs';
// import { DownLoadFile } from "./../utils/DownloadUtils";
import StringQueryBuilder from './../utils/StringQueryBuilder';
import { useLocation } from 'react-router';

const instance = axios.create({
    timeout: 120 * 1000,
    baseURL: process.env.REACT_APP_API_URL,
    paramsSerializer: params => {
        // skipNulls - skips null, undefined and empty string parameters
        // allowDots - allows query key parameters separated by dot character, example: a.b.c=a
        return qs.stringify(params, { allowDots: true, skipNulls: true });
    },
});

const api = setupCache(instance, { debug: console.log });

// get rid of the interceptor
api.interceptors.request.use(
    function (config) {
        config.headers.authorization =
            !config.url.includes('auth/login') &&
            `Bearer ${TokenService.getAccessToken()}`;
        // config.headers.authorization = config.url.includes("oauth")
        //     ? `Basic ${TokenService.getLoginToken()}`
        //     : `Bearer ${TokenService.getAccessToken()}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    response => response,
    async error => {
        const originalConfig = error.config;
        const { response } = error;
        console.log(error);

        // Check if response exists before destructuring
        if (!response) {
            AuthService.logout();
            return Promise.reject(error);
        }

        const { status } = response;
        console.log(status);

        if (status === 401) {
            AuthService.logout();
            // Redirect to login page after token expiration
            window.location.href = '/login';
            return Promise.reject(error);
        }

        // if (status === 401 && !originalConfig._retry) {
        //     originalConfig._retry = true;
        //     try {
        //         await AuthService.refreshAuth();
        //         return api(originalConfig);
        //     } catch (_error) {
        //         await AuthService.logout();
        //         // location.href = '/login';
        //         return Promise.reject(_error);
        //     }
        // }
        //window.location = "/";
        return Promise.reject(error);
    },
);

// const DEFAULT_PROVISIONING_HEADERS = {
//     'Authorization': `Bearer ${TokenService.getAccessToken()}`
// }

export const CrudRestApi = (baseURL, entity = '') => {
    return {
        getList: async (params = {}) => {
            const { data } = await api.request({
                url: `${baseURL}`,
                method: 'GET',
                params,
            });
            return data;
        },
        create: async (data, params = {}) => {
            return await api.request({
                url: `${baseURL}`,
                method: 'POST',
                data,
                params,
            });
        },
        update: async (data, id, params = {}) => {
            return await api.request({
                url: `${baseURL}/${id}`,
                method: 'PUT',
                data,
                params,
            });
        },

        // destroy: async (id, params = {}) => {
        //     return await api.request({
        //         url: `${baseURL}/delete/${id}`,
        //         method: "DELETE",
        //         params,
        //     });
        // },
        // removeLocally: async (id, params = {}) => {
        //     return await api.request({
        //         url: `${baseURL}/remove-locally/${id}`,
        //         method: "POST",
        //         params,
        //     });
        // },
        getDataMap: async params => {
            let { data } = await api.request({
                url: `${baseURL}${StringQueryBuilder(params)}`,
                method: 'GET',
            });
            return data;
        },
        delete: async (id, params = {}) => {
            return await api.request({
                url: `${baseURL}/${id}`,
                method: 'DELETE',
                params,
            });
        },
        getDataChartPolar: async params => {
            let { data } = await api.request({
                url: `${baseURL}/charts/polar${StringQueryBuilder(params)}`,
                method: 'GET',
            });
            return {
                ...data,
                days: data.days.reverse(),
            };
        },
        getDataChartLinear: async params => {
            let { data } = await api.request({
                url: `${baseURL}/charts/linear${StringQueryBuilder(params)}`,
                method: 'GET',
            });
            return data;
        },

        getEntity: async (id, params = {}) => {
            const { data } = await api.request({
                url: `${baseURL}/${id}`,
                method: 'GET',
                params,
            });
            return plainToInstance(
                entity,
                { ...data.body, errors: data?.errors },
                {
                    exposeDefaultValues: true,
                },
            );
        },
        // markPrimary: async (id, params = {}) => {
        //     return await api.request({
        //         url: `${baseURL}/mark-primary/${id}`,
        //         method: "POST",
        //         params,
        //     });
        // },
        // uploadFile: async (data, params = {}) => {
        //     return await api.request({
        //         url: `${baseURL}/upload`,
        //         method: "POST",
        //         data,
        //         params,
        //     });
        // },
        // exportFiles: async (data = {}, params = {}) => {
        //     const defaultFieldsToExport = {
        //         id: null,
        //         clientId: null,
        //         selectedIds: [],
        //     };
        //     let exportFields;
        //     if (typeof data === "function") {
        //         exportFields = data(defaultFieldsToExport);
        //     } else {
        //         exportFields = { ...defaultFieldsToExport, ...data };
        //     }
        //     return await api.request({
        //         url: `${baseURL}/export`,
        //         method: "POST",
        //         data: exportFields,
        //         params,
        //     });
        // },
        // exampleDownload: async (defaultFileName = "example") => {
        //     return await DownLoadFile(`${baseURL}/export`, defaultFileName);
        // },
        // uploadExampleFile: async (params) => {
        //     const url = `${baseURL}/example-upload`;
        //     return await api.get(url, { ...params });
        // },
        getModel: () => entity,
    };
};

export default api;
